// Allowed file types for document / attachment uploads.
//
// Keep this in sync with the server fileFilter in
// Xale-Server/src/utils/s3Uploader.ts — the server is the authoritative gate,
// this just drives the <input accept="…"> hint and the helper label so the UI
// only offers what the backend will actually accept.

/** Value for an <input type="file" accept="…"> on document uploaders. */
export const DOCUMENT_ACCEPT =
  ".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.csv,.txt,.jpg,.jpeg,.png";

/** Human-readable helper text shown under a document dropzone. */
export const DOCUMENT_ACCEPT_LABEL = "PDF, Word, Excel, PPT, JPG, PNG";
